module.exports = __webpack_public_path__ + "static/media/success-circle-icon.03766309.svg";